import { formatTime } from "lib/format-time"

export function getTailoringChanges(tailored, original) {
    const diffs = Object.keys(tailored)
        .filter((key) => key in original)
        .map((key) => {
            const tailoredValue = normaliseValue(key, tailored[key])
            const originalValue = normaliseValue(key, original[key])

            if (tailoredValue === originalValue) return null

            const displayKey = key === "classification" ? "criticality" : key

            return `${displayKey.titleize()}: ${tailoredValue} <- ${originalValue}`
        })
        .filter(Boolean)

    return diffs.join(" | ")

    function normaliseValue(key, value) {
        if (key === "skill" && value?.Skilling !== undefined) {
            return value.Skilling
        }

        if (key === "included") {
            return value ? "True" : "False"
        }

        if (key === "minutes") {
            return formatTime(value)
        }

        return value
    }
}
